const targetChars = ['A', 'C', 'E', 'G', 'O', 'U']

const parseContent = (context) => {
    let words = context.split(/\s/);

    for (let i = 0; i < words.length; i++) { 
        words[i] = words[i].toUpperCase();
        let _word = words[i];
        
        //*  Return Target Letter & It's Corresponding Index Within Word
        const targetAndIndex = targetChars.reduce((prev,letter) => {
            if(prev.length == 2){return prev}
            
            const foundIndex = _word.indexOf(letter);
            if(foundIndex > -1){
                prev.push(foundIndex,letter.toLowerCase())
                return prev;
            }
            else{return prev} 
        }, []) 

        if(targetAndIndex[0]){
            words[i] = `${_word.slice(0,targetAndIndex[0])}${targetAndIndex[1]}${_word.slice(targetAndIndex[0]+1)}`
        }

    }

    return words.reduce((prev,cur)=>{
        return `${prev} ${cur}`;
    },'')
} 

module.exports = {
    init: () => {
        const targetElements = [
            ...$('.hero.style-1 .header .h1'),
            ...$('.hero.style-2 .header .h1'),
            ...$('.btn .text')
        ]

        targetElements.forEach(element => { 
           element.innerText = parseContent(element.innerText); 
        });
    }
}